<template>
  <b-form-select
    v-model="selected"
    :options="useraccounts"
    value-field="account_id"
    text-field="account_service_address"
  >
  </b-form-select>
</template>

<script>
export default {
  props: {
    useraccounts: { type: [Array], required: false, default: null },
  },

  data() {
    return {
      selected: null,
    }
  },

  watch: {
    selected: function(val) {

      this.$store.state.auth.account_id = this.selected
      if (this.$store.state.auth.account_list.length > 0) {
        this.$store.state.auth.current_account_setup = this.$store.state.auth.account_list.filter(
          (item) => {
            return item.account_id === this.selected
          }
        )
      }

      this.$emit('accountSelected', val)

   },
  },

  mounted() {
    if (this.useraccounts.length > 0) {
      this.selected = this.useraccounts[0].account_id
    }
  },
}
</script>
